module.exports = {
  stage: 'prod',
  manifest: {
    name: 'IGQE',
    description:
      'IGQE涵蓋從初學至精通的19個等級，結合AI精準評估，由國際圍棋教育聯盟（IGEF）研發，為每位圍棋愛好者提供客觀的實力衡量。',
    default_locale: 'TW',
    appUrl: 'https://exam.igqe.org/',
    web: 'https://www.igqe.org/',
    report: 'https://forms.gle/futLsHUVn6Ac4c3A6',
    email: 'goer@email.com',
    backstage: 'https://exam.igqe.org/backstage/index.html#/',
  },
  apiDomain: 'https://tournament-api.taiwango.org/',
  certificationPermission: [],
  certificationName: 'TGA',
  awsConfigs: {
    privateBucket: 'goer-private-ap-northeast-2',
    region: 'ap-northeast-2',
    identityPoolId: 'ap-northeast-2:66397030-9a3c-481c-8359-1c2b1b84365f',
  },
};
